import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MetricsHeader',
  props: {
  title: {
    type: String,
    default: ''
  },
  timespan: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;




return { __sfc: true,props }
}

})